import { Outlet } from 'react-router-dom';
import TopBar from '../components/common/TopBar.jsx';
import Header from '../components/common/Header.jsx';
import Navbar from '../components/common/Navbar.jsx';
import Footer from '../components/common/Footer.jsx';
import CompareBar from '../components/public/products/CompareBar.jsx';
import Logo from '../components/common/Logo.jsx';
import JsonLd from '../components/common/JsonLd.jsx';
import useSiteContext from '../hooks/useSiteContext.js';
import { organizationSchema, websiteSchema } from '../utils/structuredData.js';

function MaintenanceScreen({ settings }) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-slate-50 px-4 text-center">
      <Logo className="h-14" />
      <h1 className="mt-6 text-2xl font-bold text-slate-900">
        {settings.maintenanceTitle || 'We’ll be right back'}
      </h1>
      <p className="mt-2 max-w-md text-sm text-slate-600">
        {settings.maintenanceMessage ||
          'We are updating our website. Please check back soon.'}
      </p>
    </div>
  );
}

export default function PublicLayout() {
  const { settings, origin } = useSiteContext();

  if (settings.maintenanceMode === true) {
    return <MaintenanceScreen settings={settings} />;
  }

  return (
    <div className="flex min-h-screen flex-col overflow-x-hidden">
      {/* Site-level identity, on every public page. index.html carries a static
          copy for crawlers that never run this code. */}
      <JsonLd
        id="site"
        data={[organizationSchema(settings, origin), websiteSchema(settings, origin)]}
      />
      <TopBar />
      <Header />
      <Navbar />
      <main className="min-w-0 flex-1 bg-slate-50 pb-20 lg:pb-0">
        <Outlet />
      </main>
      <Footer />
      <CompareBar />
    </div>
  );
}
